
export default {
	getModuleType: (state) => (type) => {

		return state.moduleType
    },
	getModuleSubType: (state) => (type) => {

		return state.moduleSubType
    },

    getSettingListPageType: (state) => (type) => {

		return state.page
    },

    getRequestPayload: (state) => (type) => {

		return state.payload
    },

	getSettingAllFilter: (state) => (type) => {

		return state.filters
    },
	
	getSettingFilter: (state) => (type, filterName ) => {
		if ( ! state.filters ) {

			return null
		}

		const filter = state.filters.find( ( cv ) => cv.name === filterName )

		return filter || null
    },

	getSettingAllFilterOptions: (state) => (type) => {
		return state.options
    },
	getFilterTags: (state) => (type) => {
		return state.filterTags
    },
    

    getSettingFilterOptions: (state) => (type, filterName ) => {
		
		if ( ! state.options || ! state.options[ filterName ] ) {

			return null
		}

		// cyo is only evaluated at client side 
		const testIFCyoAndDiamondListPage = state.moduleType !== 'cyo' || filterName !== 'shape' || state.page !== 'diamond' 
		if( import.meta.server || testIFCyoAndDiamondListPage ){
			return state.options[ filterName ]
		}

		// if state module is cyo check shape compatibility
		// check if user has selected a setting, 
		// then we show shape compatible with the setting
		const cyoStore 	= state.cyoStoreInstance()		
		const setting   = cyoStore.getSetting( state.moduleSubType )

		// if user has not selected a setting, then return the options
		if( !(setting && setting.avail_shapes) ){
			return state.options[ filterName ]
		}
		
		const options =  [ ...state.options[ filterName ] ]
		
		// if user has selected a setting, then we show shape compatible with the setting
		const updatedOptions = options.map(cv => ({
			...cv,
			disabled: !setting.avail_shapes.includes(cv.value) ? 1 : cv.disabled
		}))

		return updatedOptions
    },
	
	getSettingFilterVisibility: (state) => (type, filterName ) => {
		if (!state.filters) {
			return false
		}

		const filter = state.filters.find( ( cv ) => cv.name === filterName )

		return filter && filter.isOpen ? true : false
    },



    getSettingListingResult: (state) => ( ) => {
    	return state.results.data
    },

    getSettingListingCurrentPage: (state) => ( ) => {
    	return state.results.current_page
    },

    getSettingListingNextPageUrl: (state) => ( ) => {
   
       	return state.results.next_page_url
    },

    getSettingShowSkeleton: (state) => ( ) => {
   
       	return state.skeleton
    },
	getSkeletonShowMore: (state) => ( ) => {
   
		return state.showMoreSkeleton
 	},

    getSettingListingResultCount: (state) => ( ) => {
   		
   		if (state.results.total) {

   			return state.results.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
   		}
       	return state.results.total
    },

    getSettingListingCompareListCount: (state) => ( ) => {
   		
   		if (state.compare_list_count) {

   			return state.compare_list_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
   		}
       	return state.compare_list_count
    },

    getDiamondCompareListItems: (state) => ( ) => {
   		
   		return state.compare_list
    },

    getDiamondCompareListExeedStatus: (state) => ( ) => {
   		
   		return state.compare_list_count >= 40
    },

	getListingError: (state) => ( ) => {
   		
			return state.error
	}

}